export default "__VITE_ASSET__bde60b5c__"